import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationMultipleCards = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationMultipleCards',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70428)",
    fillRule: "evenodd",
    d: "M83.54 6.66c5.1.01 9.24 4.08 9.36 9.15v.25l-.09 42.01a9.375 9.375 0 0 1-9.15 9.36h-.25l-70.61-.14a9.375 9.375 0 0 1-9.36-9.15v-.25l.09-42.01c.01-5.1 4.08-9.24 9.15-9.36h.25l70.61.14Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9363F9",
    d: "m92.932 18.526-89.41.169.017 8.95 89.41-.17-.017-8.95Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70428)",
    fillRule: "evenodd",
    d: "M92.35 35.22c4.99 1.03 8.24 5.85 7.35 10.84l-.05.25-8.48 41.16c-1.03 4.99-5.85 8.24-10.84 7.35l-.25-.05-69.17-14.25c-4.99-1.03-8.24-5.85-7.35-10.84l.05-.25 8.48-41.16c1.03-4.99 5.85-8.24 10.84-7.35l.25.05 69.17 14.25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70428)",
    fillRule: "evenodd",
    d: "M97.22 58.14 9.65 40.11l1.8-8.77 87.57 18.04-1.8 8.76Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70428",
    x1: 0.195,
    x2: 95.182,
    y1: 81.963,
    y2: -7.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#E260EF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#F9D4FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70428",
    x1: -0.988,
    x2: 110.548,
    y1: 76.809,
    y2: 36.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.025,
    stopColor: "#689DDB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#7FEDAD"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70428",
    x1: 10.549,
    x2: 98.114,
    y1: 35.719,
    y2: 53.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#5B71F3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#3285F3"
  }))));
};
ColoredIllustrationMultipleCards.displayName = 'ColoredIllustrationMultipleCards';
export default withProvisionalOverrideFromContext(ColoredIllustrationMultipleCards);
//# sourceMappingURL=index.js.map